export default [
  {
    path: '/uchastki',
    name: 'uchastki',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Участки',
    },
    children: [
      {
        path: '',
        name: 'uchastki-list',
        component: () => import('@/views/uchastki/uchastki.vue'),
        meta: {},
      },
      {
        path: 'add',
        name: 'uchastki-add',
        component: () => import('@/views/uchastki/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'uchastki-edit',
        props: true,
        component: () => import('@/views/uchastki/edit.vue'),
        meta: {
          title: 'Изменить',
        },
      },
    ],
  },
]
